import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React__default, { createElement, useMemo, useRef, forwardRef } from 'react';
import { oneOfType, object, string, number, instanceOf, oneOf, node, bool, func } from 'prop-types';
import { c as DIALOG_WIDTH, d as DIALOG_WIDTH_WIDER, u as useUtils, M as MuiPickersAdapterContext } from './dimensions-bd426990.js';
import clsx from 'clsx';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { o as onSpaceOrEnter, c as createDelegatedEventHandler, e as executeInTheNextEventLoopTick } from './utils-66277a98.js';
import { p as parsePickerInputValue } from './Calendar-afaf51ae.js';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import { g as getDisplayDate, a as getTextFieldAriaText, K as KeyboardDateInput$1, v as validateDateValue, P as Picker } from './Picker-2bbc7ba8.js';
import { W as WrapperVariantContext } from './WrapperVariantContext-747fba40.js';
import Popover from '@material-ui/core/Popover';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import TrapFocus from '@material-ui/core/Modal/TrapFocus';
import Popper from '@material-ui/core/Popper';
import { u as useGlobalKeyDown, k as keycode } from './useKeyDown-e9a6112c.js';
import { u as usePickerState } from './usePickerState-71de5ec1.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var date = oneOfType([object, string, number, instanceOf(Date)]);
var datePickerView = oneOf(['year', 'month', 'day']);
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */

var timePickerDefaultProps = {
  invalidDateMessage: 'Invalid Time Format'
};
var datePickerDefaultProps = {
  minDate: new Date('1900-01-01'),
  maxDate: new Date('2100-01-01'),
  invalidDateMessage: 'Invalid Date Format',
  minDateMessage: 'Date should not be before minimal date',
  maxDateMessage: 'Date should not be after maximal date'
};
var dateTimePickerDefaultProps = _objectSpread({}, timePickerDefaultProps, {}, datePickerDefaultProps, {
  showTabs: true
});

var useStyles = makeStyles({
  dialogRoot: {
    minWidth: DIALOG_WIDTH
  },
  dialogRootWider: {
    minWidth: DIALOG_WIDTH_WIDER
  },
  dialogContainer: {
    '&:focus > $dialogRoot': {
      outline: 'auto',
      '@media (pointer:coarse)': {
        outline: 0
      }
    }
  },
  dialog: {
    '&:first-child': {
      padding: 0
    }
  },
  withAdditionalAction: {
    // set justifyContent to default value to fix IE11 layout bug
    // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
    justifyContent: 'flex-start',
    '& > *:first-child': {
      marginRight: 'auto'
    }
  }
}, {
  name: 'MuiPickersModal'
});
var ModalDialog = function ModalDialog(_ref) {
  var children = _ref.children,
      onAccept = _ref.onAccept,
      onDismiss = _ref.onDismiss,
      onClear = _ref.onClear,
      onSetToday = _ref.onSetToday,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      clearable = _ref.clearable,
      showTodayButton = _ref.showTodayButton,
      showTabs = _ref.showTabs,
      wider = _ref.wider,
      other = _objectWithoutProperties(_ref, ["children", "onAccept", "onDismiss", "onClear", "onSetToday", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "clearable", "showTodayButton", "showTabs", "wider"]);

  var classes = useStyles();
  return createElement(Dialog, _extends({
    onClose: onDismiss,
    classes: {
      container: classes.dialogContainer,
      paper: clsx(classes.dialogRoot, wider && classes.dialogRootWider)
    }
  }, other), createElement(DialogContent, {
    children: children,
    className: classes.dialog
  }), createElement(DialogActions, {
    className: clsx((clearable || showTodayButton) && classes.withAdditionalAction)
  }, clearable && createElement(Button, {
    "data-mui-test": "clear-action-button",
    color: "primary",
    onClick: onClear
  }, clearLabel), showTodayButton && createElement(Button, {
    "data-mui-test": "today-action-button",
    color: "primary",
    onClick: onSetToday
  }, todayLabel), cancelLabel && createElement(Button, {
    color: "primary",
    onClick: onDismiss
  }, cancelLabel), okLabel && createElement(Button, {
    color: "primary",
    onClick: onAccept
  }, okLabel)));
};
ModalDialog.displayName = 'ModalDialog';

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var PureDateInput = function PureDateInput(_ref) {
  var onChange = _ref.onChange,
      inputFormat = _ref.inputFormat,
      rifmFormatter = _ref.rifmFormatter,
      refuse = _ref.acceptRegex,
      mask = _ref.mask,
      rawValue = _ref.rawValue,
      maskChar = _ref.maskChar,
      validationError = _ref.validationError,
      InputProps = _ref.InputProps,
      onOpen = _ref.openPicker,
      _ref$TextFieldCompone = _ref.TextFieldComponent,
      TextFieldComponent = _ref$TextFieldCompone === void 0 ? TextField : _ref$TextFieldCompone,
      variant = _ref.variant,
      emptyLabel = _ref.emptyInputText,
      keyboardIcon = _ref.keyboardIcon,
      hideOpenPickerButton = _ref.disableOpenPicker,
      ignoreInvalidInputs = _ref.ignoreInvalidInputs,
      KeyboardButtonProps = _ref.KeyboardButtonProps,
      disableMaskedInput = _ref.disableMaskedInput,
      parsedDateValue = _ref.parsedDateValue,
      forwardedRef = _ref.forwardedRef,
      containerRef = _ref.containerRef,
      open = _ref.open,
      _ref$getOpenDialogAri = _ref.getOpenDialogAriaText,
      getOpenDialogAriaText = _ref$getOpenDialogAri === void 0 ? getTextFieldAriaText : _ref$getOpenDialogAri,
      other = _objectWithoutProperties(_ref, ["onChange", "inputFormat", "rifmFormatter", "acceptRegex", "mask", "rawValue", "maskChar", "validationError", "InputProps", "openPicker", "TextFieldComponent", "variant", "emptyInputText", "keyboardIcon", "disableOpenPicker", "ignoreInvalidInputs", "KeyboardButtonProps", "disableMaskedInput", "parsedDateValue", "forwardedRef", "containerRef", "open", "getOpenDialogAriaText"]);

  var utils = useUtils();
  var PureDateInputProps = useMemo(function () {
    return _objectSpread$1({}, InputProps, {
      readOnly: true
    });
  }, [InputProps]);
  var inputValue = getDisplayDate(rawValue, utils, {
    inputFormat: inputFormat,
    emptyInputText: emptyLabel
  });
  return createElement(TextFieldComponent, _extends({
    ref: containerRef,
    inputRef: forwardedRef,
    variant: variant,
    error: Boolean(validationError),
    helperText: validationError
  }, other, {
    "aria-label": getOpenDialogAriaText(rawValue, utils) // do not overridable
    ,
    onClick: onOpen,
    value: inputValue,
    InputProps: PureDateInputProps,
    onKeyDown: onSpaceOrEnter(onOpen)
  }));
};
PureDateInput.displayName = 'PureDateInput';

var MobileWrapper = function MobileWrapper(_ref) {
  var open = _ref.open,
      children = _ref.children,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      showTodayButton = _ref.showTodayButton,
      clearable = _ref.clearable,
      DialogProps = _ref.DialogProps,
      showTabs = _ref.showTabs,
      wider = _ref.wider,
      DateInputProps = _ref.DateInputProps,
      onClear = _ref.onClear,
      onAccept = _ref.onAccept,
      onDismiss = _ref.onDismiss,
      onSetToday = _ref.onSetToday,
      PopoverProps = _ref.PopoverProps,
      displayStaticWrapperAs = _ref.displayStaticWrapperAs,
      KeyboardDateInputComponent = _ref.KeyboardDateInputComponent,
      _ref$PureDateInputCom = _ref.PureDateInputComponent,
      PureDateInputComponent = _ref$PureDateInputCom === void 0 ? PureDateInput : _ref$PureDateInputCom,
      other = _objectWithoutProperties(_ref, ["open", "children", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "showTodayButton", "clearable", "DialogProps", "showTabs", "wider", "DateInputProps", "onClear", "onAccept", "onDismiss", "onSetToday", "PopoverProps", "displayStaticWrapperAs", "KeyboardDateInputComponent", "PureDateInputComponent"]);

  return createElement(WrapperVariantContext.Provider, {
    value: "mobile"
  }, createElement(PureDateInputComponent, _extends({
    readOnly: true
  }, other, DateInputProps)), createElement(ModalDialog, _extends({
    wider: wider,
    showTabs: showTabs,
    open: open,
    onClear: onClear,
    onAccept: onAccept,
    onDismiss: onDismiss,
    onSetToday: onSetToday,
    clearLabel: clearLabel,
    todayLabel: todayLabel,
    okLabel: okLabel,
    cancelLabel: cancelLabel,
    clearable: clearable,
    showTodayButton: showTodayButton,
    children: children,
    "data-mui-test": "mobile-wrapper-dialog"
  }, DialogProps)));
};
process.env.NODE_ENV !== "production" ? MobileWrapper.propTypes = {
  okLabel: node,
  cancelLabel: node,
  clearLabel: node,
  clearable: bool,
  todayLabel: node,
  showTodayButton: bool,
  DialogProps: object
} : void 0;
MobileWrapper.defaultProps = {
  okLabel: 'OK',
  cancelLabel: 'Cancel',
  clearLabel: 'Clear',
  todayLabel: 'Today',
  clearable: false,
  showTodayButton: false
};

var useStyles$1 = makeStyles({
  popover: {
    '&:focus': {
      outline: 'auto',
      '@media (pointer:coarse)': {
        outline: 0
      }
    }
  }
});
var DesktopWrapper = function DesktopWrapper(_ref) {
  var open = _ref.open,
      wider = _ref.wider,
      children = _ref.children,
      PopoverProps = _ref.PopoverProps,
      PopperProps = _ref.PopperProps,
      TransitionComponent = _ref.TransitionComponent,
      onClear = _ref.onClear,
      onDismiss = _ref.onDismiss,
      onSetToday = _ref.onSetToday,
      onAccept = _ref.onAccept,
      showTabs = _ref.showTabs,
      DateInputProps = _ref.DateInputProps,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      showTodayButton = _ref.showTodayButton,
      clearable = _ref.clearable,
      DialogProps = _ref.DialogProps,
      PureDateInputComponent = _ref.PureDateInputComponent,
      displayStaticWrapperAs = _ref.displayStaticWrapperAs,
      _ref$KeyboardDateInpu = _ref.KeyboardDateInputComponent,
      KeyboardDateInputComponent = _ref$KeyboardDateInpu === void 0 ? KeyboardDateInput$1 : _ref$KeyboardDateInpu,
      other = _objectWithoutProperties(_ref, ["open", "wider", "children", "PopoverProps", "PopperProps", "TransitionComponent", "onClear", "onDismiss", "onSetToday", "onAccept", "showTabs", "DateInputProps", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "showTodayButton", "clearable", "DialogProps", "PureDateInputComponent", "displayStaticWrapperAs", "KeyboardDateInputComponent"]);

  var ref = useRef(null);
  var classes = useStyles$1();
  return createElement(WrapperVariantContext.Provider, {
    value: "desktop"
  }, createElement(KeyboardDateInputComponent, _extends({}, other, DateInputProps, {
    containerRef: ref
  })), createElement(Popover, _extends({
    role: "dialog",
    open: open,
    onClose: onDismiss,
    anchorEl: ref.current,
    classes: {
      paper: classes.popover
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, PopoverProps), children));
};
process.env.NODE_ENV !== "production" ? DesktopWrapper.propTypes = {
  onOpen: func,
  onClose: func,
  PopoverProps: object
} : void 0;

var useStyles$2 = makeStyles(function (theme) {
  return {
    popper: {
      zIndex: theme.zIndex.modal
    },
    paper: {
      transformOrigin: 'top center',
      '&:focus': {
        outline: 'auto',
        '@media (pointer:coarse)': {
          outline: 0
        }
      }
    },
    topTransition: {
      transformOrigin: 'bottom center'
    }
  };
});
var DesktopPopperWrapper = function DesktopPopperWrapper(_ref) {
  var open = _ref.open,
      wider = _ref.wider,
      children = _ref.children,
      PopperProps = _ref.PopperProps,
      PopoverProps = _ref.PopoverProps,
      onClear = _ref.onClear,
      onDismiss = _ref.onDismiss,
      onSetToday = _ref.onSetToday,
      onAccept = _ref.onAccept,
      showTabs = _ref.showTabs,
      DateInputProps = _ref.DateInputProps,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      showTodayButton = _ref.showTodayButton,
      clearable = _ref.clearable,
      DialogProps = _ref.DialogProps,
      PureDateInputComponent = _ref.PureDateInputComponent,
      displayStaticWrapperAs = _ref.displayStaticWrapperAs,
      _ref$TransitionCompon = _ref.TransitionComponent,
      TransitionComponent = _ref$TransitionCompon === void 0 ? Grow : _ref$TransitionCompon,
      _ref$KeyboardDateInpu = _ref.KeyboardDateInputComponent,
      KeyboardDateInputComponent = _ref$KeyboardDateInpu === void 0 ? KeyboardDateInput$1 : _ref$KeyboardDateInpu,
      other = _objectWithoutProperties(_ref, ["open", "wider", "children", "PopperProps", "PopoverProps", "onClear", "onDismiss", "onSetToday", "onAccept", "showTabs", "DateInputProps", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "showTodayButton", "clearable", "DialogProps", "PureDateInputComponent", "displayStaticWrapperAs", "TransitionComponent", "KeyboardDateInputComponent"]);

  var classes = useStyles$2();
  var inputRef = useRef(null);
  var popperRef = useRef(null);
  useGlobalKeyDown(open, _defineProperty({}, keycode.Esc, onDismiss));

  var handleBlur = function handleBlur() {
    executeInTheNextEventLoopTick(function () {
      var _inputRef$current, _popperRef$current;

      if (((_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.contains(document.activeElement)) || ((_popperRef$current = popperRef.current) === null || _popperRef$current === void 0 ? void 0 : _popperRef$current.contains(document.activeElement))) {
        return;
      }

      onDismiss();
    });
  };

  return createElement(WrapperVariantContext.Provider, {
    value: "desktop"
  }, createElement(KeyboardDateInputComponent, _extends({}, other, DateInputProps, {
    onBlur: createDelegatedEventHandler(handleBlur, DateInputProps.onBlur),
    containerRef: inputRef
  })), createElement(Popper, _extends({
    transition: true,
    placement: "bottom",
    open: open,
    anchorEl: inputRef.current
  }, PopperProps, {
    className: clsx(classes.popper, PopperProps === null || PopperProps === void 0 ? void 0 : PopperProps.className)
  }), function (_ref2) {
    var TransitionProps = _ref2.TransitionProps,
        placement = _ref2.placement;
    return createElement(TrapFocus, {
      open: open,
      disableAutoFocus: true,
      disableEnforceFocus: true,
      isEnabled: function isEnabled() {
        return true;
      },
      getDoc: function getDoc() {
        var _ref3, _popperRef$current2;

        return (_ref3 = (_popperRef$current2 = popperRef.current) === null || _popperRef$current2 === void 0 ? void 0 : _popperRef$current2.ownerDocument) !== null && _ref3 !== void 0 ? _ref3 : document;
      }
    }, createElement(TransitionComponent, _extends({}, TransitionProps, {
      timeout: 350
    }), createElement(Paper, {
      ref: popperRef,
      onBlur: handleBlur,
      tabIndex: -1,
      elevation: 8,
      className: clsx(classes.paper, placement === 'top' && classes.topTransition)
    }, children)));
  }));
};

var makeResponsiveWrapper = function makeResponsiveWrapper(DesktopWrapperComponent, MobileWrapperComponent) {
  var ResponsiveWrapper = function ResponsiveWrapper(_ref) {
    var _ref$desktopModeBreak = _ref.desktopModeBreakpoint,
        desktopModeBreakpoint = _ref$desktopModeBreak === void 0 ? 'md' : _ref$desktopModeBreak,
        okLabel = _ref.okLabel,
        cancelLabel = _ref.cancelLabel,
        clearLabel = _ref.clearLabel,
        todayLabel = _ref.todayLabel,
        showTodayButton = _ref.showTodayButton,
        clearable = _ref.clearable,
        DialogProps = _ref.DialogProps,
        PopoverProps = _ref.PopoverProps,
        PopperProps = _ref.PopperProps,
        TransitionComponent = _ref.TransitionComponent,
        displayStaticWrapperAs = _ref.displayStaticWrapperAs,
        other = _objectWithoutProperties(_ref, ["desktopModeBreakpoint", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "showTodayButton", "clearable", "DialogProps", "PopoverProps", "PopperProps", "TransitionComponent", "displayStaticWrapperAs"]);

    var theme = useTheme();
    var isDesktop = useMediaQuery(theme.breakpoints.up(desktopModeBreakpoint));
    return isDesktop ? createElement(DesktopWrapperComponent, _extends({
      PopperProps: PopperProps,
      TransitionComponent: TransitionComponent,
      PopoverProps: PopoverProps
    }, other)) : createElement(MobileWrapperComponent, _extends({
      okLabel: okLabel,
      cancelLabel: cancelLabel,
      clearLabel: clearLabel,
      todayLabel: todayLabel,
      showTodayButton: showTodayButton,
      clearable: clearable,
      DialogProps: DialogProps
    }, other));
  };

  return ResponsiveWrapper;
};
var ResponsiveWrapper = makeResponsiveWrapper(DesktopWrapper, MobileWrapper);
var ResponsivePopperWrapper = makeResponsiveWrapper(DesktopPopperWrapper, MobileWrapper);

function withDateAdapterProp(Component) {
  return function (_ref) {
    var dateAdapter = _ref.dateAdapter,
        other = _objectWithoutProperties(_ref, ["dateAdapter"]);

    if (dateAdapter) {
      return createElement(MuiPickersAdapterContext.Provider, {
        value: dateAdapter
      }, createElement(Component, other));
    }

    return createElement(Component, other);
  };
}

/** Creates a component that rendering modal/popover/nothing and spreading props down to text field */
function makeWrapperComponent(Wrapper, _ref) {
  var KeyboardDateInputComponent = _ref.KeyboardDateInputComponent,
      PureDateInputComponent = _ref.PureDateInputComponent;

  function WrapperComponent(props) {
    var open = props.open,
        value = props.value,
        autoOk = props.autoOk,
        inputFormat = props.inputFormat,
        minDateMessage = props.minDateMessage,
        maxDateMessage = props.maxDateMessage,
        invalidDateMessage = props.invalidDateMessage,
        defaultHighlight = props.defaultHighlight,
        onChange = props.onChange,
        children = props.children,
        clearable = props.clearable,
        clearLabel = props.clearLabel,
        DialogProps = props.DialogProps,
        PopoverProps = props.PopoverProps,
        okLabel = props.okLabel,
        cancelLabel = props.cancelLabel,
        todayLabel = props.todayLabel,
        inputProps = props.inputProps,
        wrapperProps = props.wrapperProps,
        wider = props.wider,
        showTabs = props.showTabs,
        onAccept = props.onAccept,
        onClose = props.onClose,
        onOpen = props.onOpen,
        onError = props.onError,
        displayStaticWrapperAs = props.displayStaticWrapperAs,
        strictCompareDates = props.strictCompareDates,
        restPropsForTextField = _objectWithoutProperties(props, ["open", "value", "autoOk", "inputFormat", "minDateMessage", "maxDateMessage", "invalidDateMessage", "defaultHighlight", "onChange", "children", "clearable", "clearLabel", "DialogProps", "PopoverProps", "okLabel", "cancelLabel", "todayLabel", "inputProps", "wrapperProps", "wider", "showTabs", "onAccept", "onClose", "onOpen", "onError", "displayStaticWrapperAs", "strictCompareDates"]);

    var WrapperComponent = Wrapper;
    return React__default.createElement(WrapperComponent, _extends({
      clearable: clearable,
      clearLabel: clearLabel,
      DialogProps: DialogProps,
      okLabel: okLabel,
      todayLabel: todayLabel,
      cancelLabel: cancelLabel,
      DateInputProps: inputProps // @ts-ignore
      ,
      KeyboardDateInputComponent: KeyboardDateInputComponent // @ts-ignore
      ,
      PureDateInputComponent: PureDateInputComponent,
      wider: wider,
      showTabs: showTabs,
      displayStaticWrapperAs: displayStaticWrapperAs
    }, wrapperProps, restPropsForTextField), children);
  }

  return WrapperComponent;
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function makePickerWithStateAndWrapper(Wrapper, _ref) {
  var useDefaultProps = _ref.useDefaultProps,
      DefaultToolbarComponent = _ref.DefaultToolbarComponent;
  var PickerWrapper = makeWrapperComponent(Wrapper, {
    KeyboardDateInputComponent: KeyboardDateInput$1,
    PureDateInputComponent: PureDateInput
  });

  function PickerWithState(props) {
    var utils = useUtils();
    var defaultProps = useDefaultProps(props);

    var allProps = _objectSpread$2({}, defaultProps, {}, props);

    var _usePickerState = usePickerState(allProps, {
      emptyValue: null,
      parseInput: parsePickerInputValue,
      validateInput: validateDateValue,
      areValuesEqual: function areValuesEqual(a, b) {
        return utils.isEqual(a, b);
      }
    }),
        pickerProps = _usePickerState.pickerProps,
        inputProps = _usePickerState.inputProps,
        wrapperProps = _usePickerState.wrapperProps;

    var allowKeyboardControl = allProps.allowKeyboardControl,
        ampm = allProps.ampm,
        ampmInClock = allProps.ampmInClock,
        dateRangeIcon = allProps.dateRangeIcon,
        disableFuture = allProps.disableFuture,
        disableHighlightToday = allProps.disableHighlightToday,
        disablePast = allProps.disablePast,
        disableTimeValidationIgnoreDatePart = allProps.disableTimeValidationIgnoreDatePart,
        hideTabs = allProps.hideTabs,
        leftArrowButtonProps = allProps.leftArrowButtonProps,
        leftArrowButtonText = allProps.leftArrowButtonText,
        leftArrowIcon = allProps.leftArrowIcon,
        loadingIndicator = allProps.loadingIndicator,
        maxDate = allProps.maxDate,
        maxTime = allProps.maxTime,
        minDate = allProps.minDate,
        minDateTime = allProps.minDateTime,
        maxDateTime = allProps.maxDateTime,
        minTime = allProps.minTime,
        minutesStep = allProps.minutesStep,
        onMonthChange = allProps.onMonthChange,
        onYearChange = allProps.onYearChange,
        openTo = allProps.openTo,
        orientation = allProps.orientation,
        renderDay = allProps.renderDay,
        rightArrowButtonProps = allProps.rightArrowButtonProps,
        rightArrowButtonText = allProps.rightArrowButtonText,
        rightArrowIcon = allProps.rightArrowIcon,
        shouldDisableDate = allProps.shouldDisableDate,
        shouldDisableTime = allProps.shouldDisableTime,
        showDaysOutsideCurrentMonth = allProps.showDaysOutsideCurrentMonth,
        showToolbar = allProps.showToolbar,
        timeIcon = allProps.timeIcon,
        _allProps$ToolbarComp = allProps.ToolbarComponent,
        ToolbarComponent = _allProps$ToolbarComp === void 0 ? DefaultToolbarComponent : _allProps$ToolbarComp,
        toolbarFormat = allProps.toolbarFormat,
        toolbarTitle = allProps.toolbarTitle,
        value = allProps.value,
        views = allProps.views,
        restPropsForTextField = _objectWithoutProperties(allProps, ["allowKeyboardControl", "ampm", "ampmInClock", "dateRangeIcon", "disableFuture", "disableHighlightToday", "disablePast", "disableTimeValidationIgnoreDatePart", "hideTabs", "leftArrowButtonProps", "leftArrowButtonText", "leftArrowIcon", "loadingIndicator", "maxDate", "maxTime", "minDate", "minDateTime", "maxDateTime", "minTime", "minutesStep", "onMonthChange", "onYearChange", "openTo", "orientation", "renderDay", "rightArrowButtonProps", "rightArrowButtonText", "rightArrowIcon", "shouldDisableDate", "shouldDisableTime", "showDaysOutsideCurrentMonth", "showToolbar", "timeIcon", "ToolbarComponent", "toolbarFormat", "toolbarTitle", "value", "views"]);

    return createElement(PickerWrapper, _extends({
      inputProps: inputProps,
      wrapperProps: wrapperProps
    }, restPropsForTextField), createElement(Picker, _extends({}, pickerProps, {
      DateInputProps: _objectSpread$2({}, inputProps, {}, restPropsForTextField),
      allowKeyboardControl: allowKeyboardControl,
      ampm: ampm,
      ampmInClock: ampmInClock,
      dateRangeIcon: dateRangeIcon,
      disableFuture: disableFuture,
      disableHighlightToday: disableHighlightToday,
      disablePast: disablePast,
      disableTimeValidationIgnoreDatePart: disableTimeValidationIgnoreDatePart,
      hideTabs: hideTabs,
      leftArrowButtonProps: leftArrowButtonProps,
      leftArrowIcon: leftArrowIcon,
      leftArrowButtonText: leftArrowButtonText,
      loadingIndicator: loadingIndicator,
      maxDate: maxDate,
      maxTime: maxTime,
      minDate: minDate,
      minTime: minTime,
      minutesStep: minutesStep,
      onMonthChange: onMonthChange,
      onYearChange: onYearChange,
      openTo: openTo,
      orientation: orientation,
      renderDay: renderDay,
      rightArrowButtonProps: rightArrowButtonProps,
      rightArrowIcon: rightArrowIcon,
      rightArrowButtonText: rightArrowButtonText,
      shouldDisableDate: shouldDisableDate,
      shouldDisableTime: shouldDisableTime,
      showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
      showToolbar: showToolbar,
      timeIcon: timeIcon,
      ToolbarComponent: ToolbarComponent,
      toolbarFormat: toolbarFormat,
      toolbarTitle: toolbarTitle || (restPropsForTextField === null || restPropsForTextField === void 0 ? void 0 : restPropsForTextField.label),
      views: views
    })));
  }

  var FinalPickerComponent = withDateAdapterProp(PickerWithState);
  return forwardRef(function (props, ref) {
    return createElement(FinalPickerComponent, _extends({}, props, {
      forwardedRef: ref
    }));
  });
}

var useStyles$3 = makeStyles(function (theme) {
  return {
    staticWrapperRoot: {
      overflow: 'hidden',
      minWidth: DIALOG_WIDTH,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.paper
    }
  };
}, {
  name: 'MuiPickersStaticWrapper'
});
var StaticWrapper = function StaticWrapper(_ref) {
  var _ref$displayStaticWra = _ref.displayStaticWrapperAs,
      displayStaticWrapperAs = _ref$displayStaticWra === void 0 ? 'static' : _ref$displayStaticWra,
      children = _ref.children;
  var classes = useStyles$3();
  return createElement(WrapperVariantContext.Provider, {
    value: displayStaticWrapperAs
  }, createElement("div", {
    className: classes.staticWrapperRoot,
    children: children
  }));
};

export { DesktopWrapper as D, MobileWrapper as M, ResponsiveWrapper as R, StaticWrapper as S, dateTimePickerDefaultProps as a, makeWrapperComponent as b, ResponsivePopperWrapper as c, datePickerDefaultProps as d, DesktopPopperWrapper as e, makePickerWithStateAndWrapper as m, timePickerDefaultProps as t };
//# sourceMappingURL=Wrapper-4adf0bef.js.map
